module.exports = __webpack_public_path__ + "facelifting_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_7_after.jpg
// module id = 1061
// module chunks = 0